import { getRouteApi } from '@tanstack/react-router';
import { DateInput } from 'cpool-components/input/DateInput';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaLivingSituationForm } from '~/features/leadDetails/schemas/living.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type WohnhaftSeitProps = {
    antragsteller: 1 | 2;
    addressKind: 'anschrift' | 'vorherigeAnschrift';
};

const WohnhaftSeit: React.FC<WohnhaftSeitProps> = ({ addressKind, antragsteller }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaLivingSituationForm>();

    return (
        <FormField<SchemaLivingSituationForm, Date | null>
            control={control}
            name={`antragsteller${antragsteller}.wohnsituation.${addressKind}.wohnhaftSeit`}
        >
            {({ error, onChange, value }) => (
                <DateInput
                    id={`antragsteller${antragsteller}.wohnsituation.${addressKind}.wohnhaftSeit`}
                    label={t('ADDRESS.RESIDING_SINCE')}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    value={value}
                    onChange={onChange}
                    showDropdowns
                    disabled={
                        !canExecuteApplicantCommand({
                            applicant: antragsteller,
                            commandName:
                                addressKind === 'vorherigeAnschrift'
                                    ? LOAN_REQUEST_COMMANDS.changeApplicantPreviousAddress
                                    : LOAN_REQUEST_COMMANDS.changeApplicantAddress,
                            permissions,
                        })
                    }
                    error={error}
                />
            )}
        </FormField>
    );
};

export default WohnhaftSeit;
